import type { TargetingTermValue } from '../../../../models';

// create unique key using targetingTermvalue ids
export const getTargetingKey = (targetingTermValue: TargetingTermValue): string =>
  `${targetingTermValue?.category?.id}-${targetingTermValue?.dimension?.id}-${targetingTermValue?.value?.id}`;
